<template>
  <div class="py-10 md:py-20 px-4 md:px-0 bg-semantic-surface-container-high">
    <div class="md:max-w-wrapper-lg mx-auto">
      <p
        class="text-2xl/[120%] text-center md:text-4xl/[150%] mb-6 md:mb-10 text-semantic-surface-on-surface font-semibold"
      >
        Why 1 Million Aussies Choose Compare Club
      </p>

      <div class="flex md:flex-row flex-col md:gap-8 gap-4 justify-between">
        <V2MoleculesCardFeatureCard
          v-for="(item, index) in items"
          :key="index"
          :header-icon="item.icon"
          :icon-props="{
            width: 40,
            height: 40,
          }"
          :title="item.title"
          :description="item.description"
          wrapper-class="border-semantic-outline-variant-light max-w-full lg:max-w-[22rem] !h-auto"
          hide-shadow
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import V2IconsHandHeart from '~/components/v2/icons/HandHeart.vue'
import V2IconsShield from '~/components/v2/icons/Shield.vue'
import V2IconsHandPeace from '~/components/v2/icons/HandPeace.vue'

defineOptions({
  name: 'V2OrganismHomeWhyCompareClubSection'
})

const items = [
  {
    icon: V2IconsShield,
    title: 'Australia’s #1 for life and health insurance comparisons.',
    description:
      'More people trust Compare Club to help them find the right cover for their needs.'
  },
  {
    icon: V2IconsHandHeart,
    title: '300+ real humans, here to help.',
    description:
      'Our Australian experts talk to thousands every day, helping people make smarter choices about insurance, finance and utilities - without the jargon.'
  },
  {
    icon: V2IconsHandPeace,
    title: 'Independent. Unbiased. <br/>Focused on you.',
    description:
      'We’re independently owned, so you get the plan you need, not what we’ve been told to sell.'
  }
]
</script>
